export enum ModuleKey {
  ORALIA_DB = 'oraliadb',
  PATIENTS = 'patients',
  ADMINISTRATION = 'administration',
  MASTER_DATA = 'masterData'
}
